import { animated } from '@react-spring/web'
import { CircleProps } from '../models'

export default function CircleDollarSign({
  x,
  y,
  r,
  fill,
  opacity,
}: CircleProps) {
  return (
    <animated.g
      transform={`translate(${x - r}, ${y - r})scale(${(r * 2) / 25.6})`}
      opacity={opacity}
    >
      <animated.path
        d="M14.252 14.7402C14.4015 14.7844 14.5462 14.8286 14.6855 14.875C15.1723 15.0197 15.5676 15.2242 15.8701 15.4873C16.1724 15.7372 16.3232 16.0725 16.3232 16.4932C16.3232 16.8352 16.2183 17.1447 16.0078 17.4209C15.7974 17.6839 15.4685 17.8939 15.0215 18.0518C14.7992 18.1302 14.5425 18.1891 14.252 18.2285V14.7402Z"
        fill={fill}
      />
      <animated.path
        d="M12.6533 11.9473C12.5185 11.9093 12.3864 11.8748 12.2588 11.8369C11.7852 11.6922 11.3973 11.4941 11.0947 11.2441C10.8055 10.9811 10.6602 10.6395 10.6602 10.2188C10.6602 9.86368 10.7588 9.54767 10.9561 9.27148C11.1665 8.99533 11.489 8.77157 11.9229 8.60059C12.1362 8.51899 12.38 8.45673 12.6533 8.41406V11.9473Z"
        fill={fill}
      />
      <animated.path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2285 0.385742C20.2963 0.38594 26.0264 6.11573 26.0264 13.1836C26.0263 20.2514 20.2963 25.9812 13.2285 25.9814C6.16057 25.9814 0.43073 20.2515 0.430664 13.1836C0.430664 6.1156 6.16052 0.385742 13.2285 0.385742ZM12.6533 4.04297V6.26074C11.8386 6.33845 11.1347 6.51233 10.542 6.78516C9.72644 7.15348 9.11481 7.65375 8.70703 8.28516C8.3125 8.90335 8.11524 9.58721 8.11523 10.3369C8.11523 11.0736 8.26678 11.6788 8.56934 12.1523C8.87187 12.6258 9.25992 13.0075 9.7334 13.2969C10.22 13.573 10.7525 13.8032 11.3311 13.9873C11.7751 14.1156 12.2167 14.2289 12.6533 14.335V18.2627C12.0106 18.2099 11.3787 18.0745 10.7588 17.8545C9.94339 17.5651 9.25943 17.2036 8.70703 16.7695L7.81934 18.7627C8.39806 19.2493 9.18067 19.6502 10.167 19.9658C10.9655 20.2107 11.7945 20.3547 12.6533 20.4014V22.5908H14.252V20.377C15.0833 20.3038 15.8002 20.1348 16.4023 19.8672C17.2309 19.4858 17.8427 18.9863 18.2373 18.3682C18.6451 17.7367 18.8496 17.0521 18.8496 16.3154C18.8496 15.5922 18.6979 14.994 18.3955 14.5205C18.1062 14.047 17.718 13.6717 17.2314 13.3955C16.7579 13.1193 16.2248 12.8956 15.6328 12.7246C15.1766 12.5898 14.7163 12.4677 14.252 12.3574V8.37305C14.6738 8.41323 15.1077 8.49525 15.5537 8.62012C16.2114 8.79113 16.8495 9.06136 17.4678 9.42969L18.2773 7.43652C17.6722 7.04189 16.9611 6.73879 16.1455 6.52832C15.5182 6.36647 14.887 6.26684 14.252 6.22949V4.04297H12.6533Z"
        fill={fill}
      />
    </animated.g>
  )
}
